<template>
  <div class="hero-stats-professional fade-in-up delay-4">
    <StatCard
      v-for="(stat, index) in stats"
      :key="index"
      :icon="stat.icon"
      :number="stat.number"
      :label="stat.label"
      :index="index"
      :animate="animate"
      class="stat-item"
      :style="getCardStyle(index)"
    />
  </div>
</template>

<script>
import StatCard from './StatCard.vue'

export default {
  name: 'HeroStats',
  components: {
    StatCard
  },
  props: {
    stats: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(stat => 
          stat.hasOwnProperty('icon') && 
          stat.hasOwnProperty('number') && 
          stat.hasOwnProperty('label')
        )
      }
    }
  },
  data() {
    return {
      animate: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.animate = true
    }, 1000)
  },
  methods: {
    getCardStyle(index) {
      return {
        animationDelay: `${1.0 + (index * 0.15)}s`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-stats-professional {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
  max-width: 100%;
  margin-top: 8px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 16px;
  }

  @media (max-width: 991px) {
    justify-content: center;
  }
}

.stat-item {
  opacity: 0;
  transform: translateY(30px) scale(0.9);
  animation: slideUpFade 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes slideUpFade {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
